/**
 * Typiq — le panier de la nouvelle DA (snippets/cart-drawer.liquid).
 *
 * RÉACTIF D'ABORD. Chaque geste se voit au tap : le chiffre change, la
 * ligne pâlit ou apparaît, le tiroir s'ouvre dès « Ajouter » avec le pot
 * choisi ; les montants pâlissent et « Commander » attend la réponse.
 * Puis UN aller-retour : /cart/add.js ou /cart/update.js avec
 * « sections: tq-cart-render », dont la réponse porte déjà le panneau rendu
 * par Shopify (montants et dates dans la devise du marché, remises
 * comprises). Aucun calcul de prix ici.
 *
 * Les taps rapprochés sur + / − se regroupent (350 ms) en une seule
 * modification ; les gestes passent un par un (file), chacun lisant le
 * panneau laissé par le précédent.
 *
 * Les cadeaux : window.TQ.gifts (snippets/tq-head) donne la variante et le
 * seuil de chacun (0 = jamais). Le spray est aussi dû avec un abonnement
 * (dossier final : « spray offert au 1er envoi »). Le cadeau devenu dû part
 * dans le même appel que les pots, celui qui ne l'est plus aussi. Ensuite,
 * un filet (heal) relit le panneau rendu : cadeau manquant ou en trop,
 * cadeau facturé (les remises de l'admin ne le mettent pas à zéro), spray
 * payant (_upsell) devenu offert → sync(), qui recale sur /cart.js. Un
 * seuil mal réglé ne peut donc jamais faire payer un cadeau.
 *
 * Exposé : window.tqCart.add(items, meta, preview) pour la fiche, qui
 * renvoie une promesse rejetée si l'ajout échoue.
 */
(function () {
  'use strict';

  if (window.tqCart) { return; }

  var doc = document;
  var TQ = window.TQ || {};
  var base = (window.routes && window.routes.cartUrl) || '/cart';
  var track = window.tqTrack || function () {};
  var SECTION = 'tq-cart-render';

  function root() { return doc.getElementById('sidebar-cart'); }
  function asPage() { var d = root(); return !!(d && d.classList.contains('tq-cart-page')); }
  function int(v) { return parseInt(v, 10) || 0; }
  function list(v) { return String(v || '').split(',').filter(Boolean); }

  /*
   * Ce qui doit se régler juste avant que le panneau rendu par Shopify soit
   * posé : les quantités « en route » qu'il contient désormais (sinon le
   * chiffre affiché les comptait deux fois, + 1 donnait + 2 à l'écran).
   */
  var settle = [];

  /*
   * Une requête au panier ; render : la réponse apporte le panneau, posé
   * aussitôt. Shopify freine les requêtes trop rapprochées (429) et peut
   * répondre 502/503/504 un instant : la même requête repart deux fois
   * (0,7 s puis 1,6 s) avant d'annoncer un échec. Ces réponses-là n'ont
   * rien modifié, la relancer ne peut pas ajouter deux fois.
   */
  function request(path, body, render) {
    if (render && !asPage() && window.__typiqApplyCart) {
      body.sections = SECTION;
      body.sections_url = window.location.pathname;
    }
    var payload = JSON.stringify(body);
    var attempt = function (n) {
      return fetch(base + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: payload
      }).then(function (response) {
        /* Un 502-504 peut arriver après que Shopify a enregistré un ajout : on ne relance un ajout que sur 429 (refusé, rien d'enregistré). */
        if ((response.status === 429 || (response.status >= 502 && path.indexOf('/add') === -1)) && n < 2) {
          var wait = parseFloat(response.headers.get('Retry-After')) * 1000;
          if (!(wait > 0 && wait <= 3000)) { wait = n ? 1600 : 700; }
          return new Promise(function (resolve) { window.setTimeout(resolve, wait); }).then(function () { return attempt(n + 1); });
        }
        if (!response.ok) { throw new Error('cart ' + response.status); }
        return response.json();
      });
    };
    return attempt(0).then(function (json) {
      var html = body.sections && json && json.sections && json.sections[SECTION];
      if (html) {
        settle.splice(0).forEach(function (fn) { fn(); });
        window.__typiqApplyCart(html);
        json.rendered = true;
      }
      return json;
    });
  }

  function getCart() {
    return fetch(base + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.json(); });
  }

  function isGift(item) { return !!(item.properties && item.properties._gift === 'true'); }
  function isUpsell(item) { return !!(item.properties && item.properties._upsell === 'true'); }
  function isSub(item) { return !!item.selling_plan_allocation; }
  function bogo() { return !!(TQ.bogoOn && TQ.bogoOn()); }

  /* Les pots d'un panier : en achat unique (sub: false) ou en abonnement (sub: true). */
  function potsIn(cart, handles, sub) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isGift(item) && handles.indexOf(item.handle) !== -1 && isSub(item) === !!sub) { n += item.quantity; }
    }
    return n;
  }

  /* Recalage complet sur /cart.js (le filet). Résout avec le panier final. */
  function sync() {
    return getCart().then(function (cart) {
      var updates = {};
      var adds = [];
      var gifts = TQ.gifts || [];
      var sprayFree = false;
      gifts.forEach(function (gift) {
        if (!gift.variantId || !(gift.min > 0)) { return; }
        var handles = gift.from || TQ.potHandles || [];
        var count = potsIn(cart, handles, false);
        if (gift.key === 'spray' && bogo() && TQ.bogo.handle) {
          var bu = potsIn(cart, [TQ.bogo.handle], false);
          count = count - bu + Math.ceil(bu / 2);
        }
        var due = count >= gift.min || (gift.key === 'spray' && potsIn(cart, handles, true) >= 1);
        if (due && gift.key === 'spray') { sprayFree = true; }
        var lines = cart.items.filter(function (item) { return isGift(item) && item.variant_id === gift.variantId; });
        if (due && !lines.length) {
          adds.push({ id: gift.variantId, quantity: 1, properties: { _gift: 'true' } });
        }
        lines.forEach(function (line, index) {
          var wanted = due && index === 0 ? 1 : 0;
          if (line.quantity !== wanted) { updates[line.key] = wanted; }
        });
      });
      if (sprayFree) {
        cart.items.forEach(function (item) { if (isUpsell(item)) { updates[item.key] = 0; } });
      }
      var chain = Promise.resolve();
      if (Object.keys(updates).length) { chain = chain.then(function () { return request('/update.js', { updates: updates }); }); }
      if (adds.length) { chain = chain.then(function () { return request('/add.js', { items: adds })['catch'](function () {}); }); }
      if (!Object.keys(updates).length && !adds.length) { return cart; }
      return chain.then(getCart).then(function (fresh) {
        var charged = {};
        fresh.items.forEach(function (item) { if (isGift(item) && item.final_line_price > 0 && !(bogo() && item.variant_id === TQ.sprayVariantId && sprayCovered(fresh, item))) { charged[item.key] = 0; } });
        if (!Object.keys(charged).length) { return fresh; }
        return request('/update.js', { updates: charged });
      });
    });
  }

  function sprayCovered(cart, item) {
    return (cart.cart_level_discount_applications || []).some(function (a) {
      return /spray/i.test(a.title || '') && (a.total_allocated_amount || 0) + 5 >= item.final_line_price;
    });
  }

  function rerender() {
    /* La page panier se recharge : le rendu « drawer » est celui du tiroir. */
    if (asPage()) { window.location.reload(); return new Promise(function () {}); }
    if (typeof window.__typiqRerenderCart === 'function') { return window.__typiqRerenderCart(); }
    doc.dispatchEvent(new CustomEvent('cart:refresh'));
    return Promise.resolve();
  }

  function open() {
    var drawer = root();
    if (!drawer || drawer.getAttribute('aria-hidden') === 'false' || asPage()) { return; }
    var opener = doc.createElement('button');
    opener.type = 'button';
    opener.hidden = true;
    opener.setAttribute('data-action', 'open-drawer');
    opener.setAttribute('data-drawer-id', 'sidebar-cart');
    doc.body.appendChild(opener);
    opener.click();
    opener.parentNode.removeChild(opener);
  }

  /* ── Ce que le panneau affiché dit du panier ──────────────────────── */

  function form() { var d = root(); return d && d.querySelector('form.Cart'); }

  function domState() {
    var f = form();
    var st = { pots: 0, fibres: 0, subs: 0, gifts: {}, upsell: [] };
    if (!f) { return st; }
    st.pots = int(f.getAttribute('data-pots'));
    st.fibres = int(f.getAttribute('data-pots-fibres'));
    st.subs = int(f.getAttribute('data-subs'));
    st.upsell = list(f.getAttribute('data-upsell'));
    var rows = f.querySelectorAll('.tq-gift[data-gift-variant]');
    for (var i = 0; i < rows.length; i++) {
      var v = int(rows[i].getAttribute('data-gift-variant'));
      (st.gifts[v] = st.gifts[v] || []).push(rows[i].getAttribute('data-key'));
    }
    return st;
  }

  /* Les cadeaux à ajouter ou retirer pour un nombre de pots donné. */
  function giftPlan(st, pots, subs) {
    var plan = { adds: [], updates: {}, sprayFree: false };
    (TQ.gifts || []).forEach(function (gift) {
      if (!gift.variantId || !(gift.min > 0)) { return; }
      /* Chaque applicateur suit les pots de son produit (le compact ou les fibres), le spray suit tous les pots. */
      var count = gift.key === 'app-fibres' ? st.fibres : gift.key === 'app-compact' ? pots - st.fibres : pots;
      if (gift.key === 'spray' && bogo()) { count = st.fibres + Math.ceil((pots - st.fibres) / 2); }
      var due = count >= gift.min || (gift.key === 'spray' && subs >= 1);
      var keys = st.gifts[gift.variantId] || [];
      if (due && !keys.length) { plan.adds.push({ id: gift.variantId, quantity: 1, properties: { _gift: 'true' } }); }
      keys.forEach(function (key, index) { if (!due || index > 0) { plan.updates[key] = 0; } });
      if (due && gift.key === 'spray') {
        plan.sprayFree = true;
        st.upsell.forEach(function (key) { plan.updates[key] = 0; });
      }
    });
    return plan;
  }

  /* Ajoute des articles, avec les cadeaux devenus dus ; un spray payant devenu offert part avant. */
  function addItems(items, dPots, dSubs) {
    var st = domState();
    var plan = giftPlan(st, st.pots + dPots, st.subs + dSubs);
    if (plan.sprayFree) { items = items.filter(function (item) { return !(item.properties && item.properties._upsell); }); }
    var first = Object.keys(plan.updates).length ? request('/update.js', { updates: plan.updates }) : Promise.resolve();
    /* Les cadeaux partent dans un second appel dont l'échec est ignoré : un cadeau épuisé ou dépublié ne doit jamais bloquer l'ajout des pots. */
    /*
     * Pots et cadeaux dans UN seul appel (un aller-retour de moins : ~0,5 s
     * en 4G). Shopify refuse tout l'appel (422) si un article manque : on
     * repart alors sur deux appels, pots d'abord, cadeau ensuite.
     */
    var twoCalls = function () {
      var main = items.length ? request('/add.js', { items: items }, !plan.adds.length) : Promise.resolve(null);
      return main.then(function (res) {
        if (!plan.adds.length) { return res; }
        return request('/add.js', { items: plan.adds }, true)['catch'](function () {
          /* Cadeau refusé : on redessine quand même le panier avec les pots ajoutés. */
          return request('/update.js', { updates: {} }, true)['catch'](function () { return res; });
        });
      });
    };
    var giftsOk = plan.adds.every(function (add) { return (TQ.gifts || []).some(function (g) { return g.variantId === add.id && g.available; }); });
    return first.then(function () {
      if (!items.length || !plan.adds.length || !giftsOk) { return twoCalls(); }
      return request('/add.js', { items: items.concat(plan.adds) }, true)['catch'](function (err) {
        if (!err || err.message !== 'cart 422') { throw err; }
        /* Refus : on retire un cadeau éventuellement passé seul, puis on refait en deux temps. */
        var undo = {};
        plan.adds.forEach(function (add) { undo[add.id] = 0; });
        return request('/update.js', { updates: undo })['catch'](function () {}).then(twoCalls);
      });
    });
  }

  /* Fixe des quantités, avec les cadeaux qui ne sont plus dus dans le même appel. */
  function setQty(updates, dPots, dSubs) {
    var st = domState();
    var plan = giftPlan(st, st.pots + dPots, st.subs + dSubs);
    Object.keys(plan.updates).forEach(function (key) { if (!(key in updates)) { updates[key] = plan.updates[key]; } });
    var done = request('/update.js', { updates: updates }, true);
    if (plan.adds.length) { done = done.then(function () { return request('/add.js', { items: plan.adds }, true); }); }
    return done;
  }

  /* ── La file : un geste après l'autre ─────────────────────────────── */

  var queue = Promise.resolve();
  var inflight = 0;

  function busy() {
    var on = inflight > 0 || Object.keys(pend).length > 0;
    var d = root();
    if (d) { d.classList[on ? 'add' : 'remove']('is-busy'); }
    return on;
  }

  function enqueue(job) {
    inflight++;
    busy();
    doc.dispatchEvent(new CustomEvent('theme:loading:start'));
    var result = queue.then(job);
    queue = result.then(function (json) { return json && json.rendered ? null : rerender(); }, function () { return rerender(); })
      .then(function () {
        inflight--;
        busy();
        doc.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (!inflight) { heal(); }
      });
    return result;
  }

  function whenIdle() { return queue.then(function () { return inflight || Object.keys(pend).length ? whenIdle() : null; }); }

  /* ── Lignes : + / − regroupés, chiffre affiché tout de suite ──────── */

  var pend = {};   /* taps pas encore envoyés, par ligne */
  var sent = {};   /* envoyés, pas encore rendus */

  function lineId(line) {
    return (line.getAttribute('data-variant-id') || '') + ':' + (line.getAttribute('data-plan') || 0) + (line.classList.contains('tq-line--pot') ? ':p' : ':o');
  }
  function findLine(id) {
    var d = root();
    var lines = d ? d.querySelectorAll('[data-tq-line]') : [];
    for (var i = 0; i < lines.length; i++) { if (lineId(lines[i]) === id) { return lines[i]; } }
    return null;
  }
  function rowId(r) { return r.variant + ':' + (r.plan || 0) + (r.pot === false ? ':o' : ':p'); }
  function offset(id) { return (pend[id] ? pend[id].delta : 0) + (sent[id] || 0); }

  /* Le chiffre de chaque ligne = quantité du panneau + ce qui est en route (recalé à chaque fois, même à zéro). */
  function showPending() {
    var d = root();
    var lines = d ? d.querySelectorAll('[data-tq-line]:not([data-tq-pending])') : [];
    for (var i = 0; i < lines.length; i++) {
      var qty = Math.max(0, int(lines[i].getAttribute('data-qty')) + offset(lineId(lines[i])));
      var step = int(lines[i].getAttribute('data-step')) || 1;
      var shown = step > 1 ? Math.max(0, int(lines[i].getAttribute('data-paid')) + Math.round(offset(lineId(lines[i])) / step)) : qty;
      var counter = lines[i].querySelector('.tq-stepper span');
      if (counter && counter.textContent !== String(shown)) { counter.textContent = String(shown); }
      lines[i].classList.toggle('is-leaving', qty === 0);
    }
  }
  doc.addEventListener('cart:updated', showPending);

  function lineJob(id, d) {
    var line = findLine(id);
    if (!line || !d) { return Promise.resolve(null); }
    var isPot = line.classList.contains('tq-line--pot');
    var planId = int(line.getAttribute('data-plan'));
    var dPots = isPot && !planId ? d : 0;
    var dSubs = isPot && planId ? d : 0;
    if (d > 0) {
      var item = { id: int(line.getAttribute('data-variant-id')), quantity: d };
      if (planId) { item.selling_plan = planId; }
      return addItems([item], dPots, dSubs);
    }
    var keys = list(line.getAttribute('data-keys'));
    var qtys = list(line.getAttribute('data-key-qtys')).map(int);
    var left = -d;
    var updates = {};
    for (var i = keys.length - 1; i >= 0 && left > 0; i--) {
      var take = Math.min(qtys[i] || 0, left);
      updates[keys[i]] = (qtys[i] || 0) - take;
      left -= take;
    }
    return setQty(updates, dPots, dSubs);
  }

  function flush(id) {
    var p = pend[id];
    if (!p) { return; }
    window.clearTimeout(p.timer);
    delete pend[id];
    var d = p.delta;
    if (!d) { busy(); return; }
    sent[id] = (sent[id] || 0) + d;
    var released = false;
    var release = function () { if (!released) { released = true; sent[id] -= d; } };
    enqueue(function () {
      settle.push(release);
      return lineJob(id, d).then(function (json) { release(); showPending(); return json; }, function (error) { release(); showPending(); throw error; });
    })['catch'](function () {});
  }

  function bump(line, d, now, units) {
    var id = lineId(line);
    var p = pend[id] || (pend[id] = { delta: 0, timer: 0 });
    var qty = int(line.getAttribute('data-qty'));
    var step = int(line.getAttribute('data-step')) || 1;
    if (step > 1 && !units && Math.abs(d) < 1e5) { d *= step; }
    p.delta = Math.max(-(qty + (sent[id] || 0)), p.delta + d);
    busy();
    showPending();
    window.clearTimeout(p.timer);
    if (now) { flush(id); } else { p.timer = window.setTimeout(function () { flush(id); }, 350); }
  }

  /* ── Fiche produit → panier ───────────────────────────────────────── */

  /* Le pot choisi paraît dans le tiroir dès le clic ; le rendu Shopify le remplace. */
  function preview(rows) {
    var f = form();
    if (!f || !rows || !rows.length || asPage()) { return; }
    var body = f.querySelector('.tq-cart__body');
    if (!body) {
      var empty = f.querySelector('.tq-cart__empty');
      if (empty) { empty.hidden = true; }
      body = doc.createElement('div');
      body.className = 'tq-cart__body';
      body.setAttribute('data-scrollable', '');
      var head = f.querySelector('.tq-cart__head');
      f.insertBefore(body, head ? head.nextSibling : f.firstChild);
      f.classList.remove('is-empty');
    }
    /* Panier vide jusque-là : le pied (sous-total, bouton) paraît tout de suite, en attente du rendu Shopify. */
    if (!f.querySelector('.tq-cart__foot')) {
      var foot = doc.createElement('div');
      foot.className = 'tq-cart__foot is-skeleton';
      foot.innerHTML = '<div class="tq-cart__total"><span></span><span class="tq-cart__amount tq-skel" aria-hidden="true"></span></div><p class="tq-cart__delivery"><span class="tq-skel tq-skel--line" aria-hidden="true"></span></p><button type="button" class="tq-horizon tq-horizon--cart tq-horizon--pill is-waiting" data-tq="checkout-early"><span class="tq-horizon__lines"><span class="tq-horizon__main"></span></span></button><div class="tq-pay" aria-hidden="true"><span class="tq-pay__item"></span></div>';
      foot.querySelector('.tq-cart__total span').textContent = f.getAttribute('data-l-subtotal') || '';
      foot.querySelector('.tq-horizon__main').textContent = f.getAttribute('data-l-checkout') || '';
            f.appendChild(foot);
    }
    var anchor = body.firstChild;
    rows.forEach(function (r) {
      if (r.spray) {
        if (body.querySelector('.tq-gift')) { return; }
        var g = doc.createElement('div');
        g.className = 'tq-gift is-pending';
        g.setAttribute('data-tq-pending', '');
        if (!r.gift) { g.setAttribute('data-paid', ''); }
        g.innerHTML = '<span class="tq-line__thumb tq-line__thumb--dark"></span><span class="tq-gift__name"></span><span class="tq-gift__tag"></span>';
        if (r.img) { g.firstChild.style.backgroundImage = 'url("' + r.img + '")'; }
        g.children[1].textContent = r.name || '';
        if (!r.gift && f.getAttribute('data-l-remove')) {
          var rm = doc.createElement('span');
          rm.className = 'tq-link tq-link--dim';
          rm.setAttribute('aria-hidden', 'true');
          rm.textContent = f.getAttribute('data-l-remove');
          g.children[1].appendChild(rm);
        }
        g.children[2].textContent = r.tag || '';
        body.insertBefore(g, anchor);
        return;
      }
      var id = rowId(r);
      if (findLine(id)) { sent[id] = (sent[id] || 0) + r.qty; return; }
      var same = r.product && body.querySelector('.tq-line--pot[data-product="' + r.product + '"]' + (r.plan ? '[data-plan="' + r.plan + '"]' : ':not([data-plan])') + ':not([data-tq-pending])');
      if (same) { var sid = lineId(same); sent[sid] = (sent[sid] || 0) + r.qty; return; }
      var line = doc.createElement('div');
      var dot = r.pot === false ? 'tq-line__thumb' : (r.potImg ? 'tq-line__thumb tq-line__thumb--dark tq-line__thumb--pot' : 'tq-line__swatch');
      var gift = r.tag && r.paid === 0;
      line.className = 'tq-line is-pending' + (r.pot === false ? '' : ' tq-line--pot') + (gift ? ' tq-line--gift' : '');
      line.setAttribute('data-tq-pending', '');
      line.innerHTML = '<div class="tq-line__row"><span class="' + dot + '"></span><div class="tq-line__info"><span class="tq-line__name"></span><span class="tq-line__shade"></span></div>' + (gift ? '' : '<div class="tq-stepper"><button type="button" disabled>−</button><span></span><button type="button" disabled>+</button></div>') + '</div>';
      var pic = r.potImg || r.img;
      if (pic) { line.querySelector('.' + dot.split(' ')[0]).style.backgroundImage = 'url("' + pic + '")'; }
      line.querySelector('.tq-line__name').textContent = r.name || '';
      line.querySelector('.tq-line__shade').textContent = r.shade || '';
      if (r.tag) {
        var tag = doc.createElement('span');
        tag.className = 'tq-line__bogo';
        tag.textContent = r.tag;
        if (r.was) { var was = doc.createElement('s'); was.textContent = r.was; tag.appendChild(was); }
        line.querySelector('.tq-line__info').appendChild(tag);
      }
      if (r.pot !== false && f.getAttribute('data-l-change')) {
        var links = doc.createElement('div');
        links.className = 'tq-line__links';
        links.setAttribute('aria-hidden', 'true');
        links.innerHTML = '<span class="tq-link"></span><span class="tq-link tq-link--dim"></span>';
        links.children[0].textContent = f.getAttribute('data-l-change');
        links.children[1].textContent = f.getAttribute('data-l-remove') || '';
        line.querySelector('.tq-line__info').appendChild(links);
        var st = line.querySelector('.tq-line__row > .tq-stepper');
        if (st) { links.removeAttribute('aria-hidden'); links.children[0].setAttribute('aria-hidden', 'true'); links.children[1].setAttribute('aria-hidden', 'true'); links.appendChild(st); }
      }
      var count = line.querySelector('.tq-stepper span');
      if (count) { count.textContent = String(r.paid != null ? r.paid : r.qty); }
      body.insertBefore(line, anchor);
    });
    showPending();
  }

  window.tqCart = {
    add: function (items, meta, rows) {
      var wasOpen = root() && root().getAttribute('aria-hidden') === 'false';
      /* Les pots ajoutés, d'après les lignes montrées (pot: false pour un autre article). */
      var dPots = 0;
      var dSubs = 0;
      (rows || []).forEach(function (r) {
        if (r.pot === false) { return; }
        if (r.plan) { dSubs += r.qty; } else { dPots += r.qty; }
      });
      preview(rows);
      open();
      var cleared = false;
      var release = function () {
        if (cleared) { return; }
        cleared = true;
        (rows || []).forEach(function (r) { var id = rowId(r); if (sent[id]) { sent[id] = Math.max(0, sent[id] - r.qty); } });
      };
      var result = enqueue(function () { settle.push(release); return addItems(items.slice(), dPots, dSubs); });
      var clear = function () { release(); showPending(); };
      return result.then(function (json) {
        clear();
        track('add_to_cart', meta || {});
        return json;
      }, function (error) {
        clear();
        if (!wasOpen) {
          var close = root() && root().querySelector('[data-action="close-drawer"]');
          if (close) { close.click(); }
        }
        throw error;
      });
    },
    open: open,
    sync: sync
  };

  /* ── « Vos teintes » : la teinte de chaque pot ─────────────────────── */

  /*
   * Les pots du même produit et de la même formule (achat unique, ou même
   * abonnement) que la ligne touchée, un par unité, dans l'ordre des lignes.
   * Un pot choisi, une teinte touchée : elle lui est donnée, et l'onglet
   * reste sur ce pot (on change de pot en touchant son onglet ; le passage
   * automatique, retiré le 25/10, embrouillait). « Valider » envoie
   * seulement la différence :
   * les teintes en plus d'abord (add), puis celles en moins (update), pour
   * que le panier ne perde jamais un pot si la seconde requête échoue.
   */
  var sh = null;

  function shadesView() { var d = root(); return d && d.querySelector('[data-tq-shades-view]'); }

  function shadeList(line) {
    var dots = line.querySelectorAll('[data-tq-shades] [data-to]');
    var out = [];
    for (var i = 0; i < dots.length; i++) {
      out.push({ id: int(dots[i].getAttribute('data-to')), name: dots[i].getAttribute('aria-label') || '', bg: dots[i].style.backgroundImage || '', off: dots[i].disabled });
    }
    return out;
  }

  function openShades(line) {
    var view = shadesView();
    var d = root();
    if (!view || !d) { return; }
    /* Des « + / − » sont encore en route : on attend que le panier soit à jour avant de lire les quantités (sinon la sauvegarde partait d'un compte faux). */
    if (Object.keys(pend).length || inflight) {
      Object.keys(pend).forEach(flush);
      var vid = line.getAttribute('data-variant-id');
      var pid = line.getAttribute('data-plan');
      whenIdle().then(function () {
        var dd = root();
        var fresh = dd && dd.querySelector('.tq-line--pot[data-variant-id="' + vid + '"]' + (pid ? '[data-plan="' + pid + '"]' : ':not([data-plan])'));
        if (fresh) { openShades(fresh); }
      });
      return;
    }
    var plan = int(line.getAttribute('data-plan'));
    var product = line.getAttribute('data-product');
    var lines = d.querySelectorAll('.tq-line--pot[data-tq-line]');
    var pots = [];
    var current = {};
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-product') !== product || int(lines[i].getAttribute('data-plan')) !== plan) { continue; }
      var mix = lines[i].getAttribute('data-mix') ? list(lines[i].getAttribute('data-mix')) : [lines[i].getAttribute('data-variant-id') + ':' + lines[i].getAttribute('data-qty')];
      mix.forEach(function (pair) {
        var v = int(pair.split(':')[0]);
        var q = int(pair.split(':')[1]);
        if (!v || !q) { return; }
        current[v] = (current[v] || 0) + q;
        for (var k = 0; k < q; k++) { pots.push(v); }
      });
    }
    if (!pots.length) { return; }
    var start = 0;
    if (!line.getAttribute('data-mix')) { for (var j = 0; j < pots.length; j++) { if (pots[j] === int(line.getAttribute('data-variant-id'))) { start = j; break; } } }
    sh = { line: line, plan: plan, product: product, list: shadeList(line), pots: pots, was: pots.slice(), current: current, active: start, lines: [] };
    for (var m = 0; m < lines.length; m++) {
      if (lines[m].getAttribute('data-product') === product && int(lines[m].getAttribute('data-plan')) === plan) {
        sh.lines.push({ variant: int(lines[m].getAttribute('data-variant-id')), keys: list(lines[m].getAttribute('data-keys')), qtys: list(lines[m].getAttribute('data-key-qtys')).map(int) });
      }
    }
    var potsEl = view.querySelector('[data-tq-shades-pots]');
    var grid = view.querySelector('[data-tq-shades-grid]');
    var label = view.getAttribute('data-l-pot') || 'Pot %n%';
    potsEl.innerHTML = '';
    grid.innerHTML = '';
    if (pots.length > 1) {
      pots.forEach(function (v, n) {
        var b = doc.createElement('button');
        b.type = 'button';
        b.className = 'tq-shades__pot';
        b.setAttribute('role', 'tab');
        b.setAttribute('data-tq-shades-pot', String(n));
        b.innerHTML = '<span aria-hidden="true"></span>';
        b.appendChild(doc.createTextNode(label.replace('%n%', String(n + 1))));
        potsEl.appendChild(b);
      });
    }
    sh.list.forEach(function (x) {
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'tq-shades__shade';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-tq-shades-to', String(x.id));
      if (x.off) { b.disabled = true; }
      var dot = doc.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      if (x.bg) { dot.style.backgroundImage = x.bg; }
      b.appendChild(dot);
      b.appendChild(doc.createTextNode(x.name));
      grid.appendChild(b);
    });
    paintShades();
    d.classList.remove('is-back');
    d.classList.add('is-shading');
    view.hidden = false;
    var body = view.querySelector('.tq-shades__body');
    if (body) { body.scrollTop = 0; }
    var active = potsEl.querySelector('.is-on');
    if (active && active.scrollIntoView) { active.scrollIntoView({ block: 'nearest', inline: 'center' }); }
    var back = view.querySelector('[data-tq-shades-back]');
    if (back) { try { back.focus({ preventScroll: true }); } catch (e) {} }
    track('cart_shades_open', { pots: pots.length });
  }

  function nameOf(id) { for (var i = 0; i < sh.list.length; i++) { if (sh.list[i].id === id) { return sh.list[i].name; } } return ''; }
  function bgOf(id) { for (var i = 0; i < sh.list.length; i++) { if (sh.list[i].id === id) { return sh.list[i].bg; } } return ''; }

  function paintShades() {
    var view = shadesView();
    if (!view || !sh) { return; }
    var tabs = view.querySelectorAll('[data-tq-shades-pot]');
    for (var i = 0; i < tabs.length; i++) {
      var on = i === sh.active;
      tabs[i].classList.toggle('is-on', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].setAttribute('aria-label', tabs[i].textContent + ' · ' + nameOf(sh.pots[i]));
      var dot = tabs[i].querySelector('span');
      if (dot) { dot.style.backgroundImage = bgOf(sh.pots[i]); }
    }
    var f = view.querySelector('[data-tq-shades-for]');
    if (f) { f.hidden = tabs.length < 2; f.textContent = tabs[sh.active] ? f.getAttribute('data-l').replace('%p%', tabs[sh.active].textContent) : ''; }
    var cur = sh.pots[sh.active];
    var opts = view.querySelectorAll('[data-tq-shades-to]');
    for (var k = 0; k < opts.length; k++) { opts[k].setAttribute('aria-checked', int(opts[k].getAttribute('data-tq-shades-to')) === cur ? 'true' : 'false'); }
    var names = [];
    sh.pots.forEach(function (v) { var n = nameOf(v); if (names.indexOf(n) === -1) { names.push(n); } });
    var sum = view.querySelector('[data-tq-shades-sum]');
    if (sum) { sum.textContent = names.join(' · '); }
  }

  function closeShades(back) {
    var d = root();
    var view = shadesView();
    if (!d || !view || view.hidden) { return; }
    view.hidden = true;
    d.classList.remove('is-shading');
    if (back) { d.classList.add('is-back'); window.setTimeout(function () { d.classList.remove('is-back'); }, 400); }
    sh = null;
  }

  /*
   * Enregistre : les teintes en plus d'abord (add), puis les retraits,
   * calculés sur le panier RELU après l'ajout. Shopify regroupe ou découpe
   * les lignes d'une même teinte au gré des remises de lot : les clés du
   * panneau d'avant l'ajout n'étaient plus les bonnes (8 pots Brun devenus
   * 12 au lieu de 7). Le panier ne perd jamais un pot si le retrait échoue.
   */
  function saveShades() {
    if (!sh) { return; }
    var want = {};
    sh.pots.forEach(function (v) { want[v] = (want[v] || 0) + 1; });
    var plan = sh.plan;
    var product = sh.product;
    var adds = [];
    var changed = false;
    Object.keys(want).forEach(function (v) {
      var more = want[v] - (sh.current[v] || 0);
      if (more > 0) { var item = { id: int(v), quantity: more }; if (plan) { item.selling_plan = plan; } adds.push(item); }
    });
    Object.keys(sh.current).forEach(function (v) { if ((want[v] || 0) !== sh.current[v]) { changed = true; } });
    track('cart_shades_save', { pots: sh.pots.length, changed: changed });
    closeShades(true);
    if (!changed) { return; }
    var f = form();
    if (f) { f.classList.add('is-reshading'); }
    enqueue(function () {
      var first = adds.length ? request('/add.js', { items: adds }) : Promise.resolve(null);
      return first.then(getCart).then(function (cart) {
        var have = {};
        var lines = cart.items.filter(function (item) {
          var itemPlan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : 0;
          return item.handle === product && !isGift(item) && itemPlan === plan;
        });
        lines.forEach(function (item) { have[item.variant_id] = (have[item.variant_id] || 0) + item.quantity; });
        var updates = {};
        Object.keys(have).forEach(function (v) {
          var less = have[v] - (want[v] || 0);
          for (var i = lines.length - 1; i >= 0 && less > 0; i--) {
            if (String(lines[i].variant_id) !== String(v)) { continue; }
            var take = Math.min(lines[i].quantity, less);
            updates[lines[i].key] = lines[i].quantity - take;
            less -= take;
          }
        });
        return Object.keys(updates).length ? request('/update.js', { updates: updates }, true) : null;
      });
    })['catch'](function () {}).then(function () { var g = form(); if (g) { g.classList.remove('is-reshading'); } });
  }

  doc.addEventListener('click', function (event) {
    var view = event.target.closest('[data-tq-shades-view]');
    if (!view || !sh) { return; }
    var tab = event.target.closest('[data-tq-shades-pot]');
    if (tab) { sh.active = int(tab.getAttribute('data-tq-shades-pot')); paintShades(); return; }
    var opt = event.target.closest('[data-tq-shades-to]');
    if (opt && !opt.disabled) {
      var to = int(opt.getAttribute('data-tq-shades-to'));
      var n = sh.active;
      sh.pots[n] = to;
      track('shade_select', { shade: nameOf(to), source: 'panier' });
      var tabs = view.querySelectorAll('[data-tq-shades-pot]');
      if (tabs[n]) { tabs[n].classList.remove('is-set'); void tabs[n].offsetWidth; tabs[n].classList.add('is-set'); }
      paintShades();
      return;
    }
    if (event.target.closest('[data-tq-shades-back]')) { closeShades(true); return; }
    if (event.target.closest('[data-tq-shades-done]')) { saveShades(); }
  });
  doc.addEventListener('drawer:closed', function (event) { if (event.target && event.target.id === 'sidebar-cart') { closeShades(false); } });
  window.tqCartShadesBack = function () { if (sh) { closeShades(true); return true; } return false; };

  /* ── Gestes du panneau ────────────────────────────────────────────── */

  doc.addEventListener('click', function (event) {
    var control = event.target.closest('#sidebar-cart [data-tq]');
    if (!control) { return; }
    var action = control.getAttribute('data-tq');
    var line = control.closest('[data-tq-line]');

    /* « Passer au paiement » touché avant le premier rendu (ajout en cours) : on part au paiement dès que le panier est enregistré. */
    if (action === 'checkout-early') {
      event.preventDefault();
      if (control.getAttribute('data-going')) { return; }
      control.setAttribute('data-going', '1');
      track('checkout_click', {});
      Object.keys(pend).forEach(flush);
      whenIdle().then(function () { window.location.href = '/checkout'; });
      return;
    }

    if (action === 'checkout') {
      track('checkout_click', {});
      /* Une modification en route : on part au paiement quand elle est enregistrée. */
      if (busy()) {
        event.preventDefault();
        control.classList.add('is-waiting');
        Object.keys(pend).forEach(flush);
        whenIdle().then(function () { window.location.href = '/checkout'; });
      }
      return;
    }

    if (action === 'edit' && line) {
      event.preventDefault();
      if (line.querySelector('[data-tq-shades]')) { openShades(line); }
      return;
    }

    if (!line && ['spray-add', 'spray-remove', 'nudge'].indexOf(action) === -1) { return; }
    event.preventDefault();
    if (control.disabled) { return; }

    if (action === 'inc') {
      bump(line, 1);
    } else if (action === 'dec') {
      bump(line, -1);
    } else if (action === 'remove') {
      bump(line, -1e6, true);
    } else if (action === 'shade') {
      var to = int(control.getAttribute('data-to'));
      var from = int(line.getAttribute('data-variant-id'));
      if (!to || to === from) { return; }
      track('cart_shade_change', { from: from, to: to, source: 'panier' });
      track('shade_select', { shade: control.getAttribute('aria-label'), source: 'panier' });
      /* Tout de suite : la pastille et le nom de la nouvelle teinte. */
      var swatch = line.querySelector('.tq-line__swatch');
      if (swatch && control.style.backgroundImage) { swatch.style.backgroundImage = control.style.backgroundImage; }
      var shadeText = line.querySelector('.tq-line__shade');
      var onDot = line.querySelector('.tq-dot.is-on');
      var oldShade = onDot ? onDot.getAttribute('aria-label') : '';
      if (shadeText && oldShade) { shadeText.textContent = shadeText.textContent.replace(oldShade, control.getAttribute('aria-label')); }
      var dots = line.querySelectorAll('.tq-dot');
      for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle('is-on', dots[k] === control); }
      var id = lineId(line);
      if (pend[id]) { flush(id); }
      enqueue(function () {
        var current = findLine(id);
        if (!current) { return null; }
        var qty = int(current.getAttribute('data-qty'));
        var planId = int(current.getAttribute('data-plan'));
        var updates = {};
        list(current.getAttribute('data-keys')).forEach(function (key) { updates[key] = 0; });
        var item = { id: to, quantity: qty };
        if (planId) { item.selling_plan = planId; }
        /* La nouvelle teinte d'abord, l'ancienne ensuite : si l'ajout échoue, le pot reste dans le panier. */
        return request('/add.js', { items: [item] }).then(function () { return request('/update.js', { updates: updates }, true); });
      })['catch'](function () {});
    } else if (action === 'spray-add') {
      track('cart_upsell_click', { item: 'spray' });
      control.disabled = true;
      var offer = control.closest('.tq-offer');
      if (offer) { offer.classList.add('is-pending'); }
      var spray = int(control.getAttribute('data-variant-id'));
      enqueue(function () { return addItems([{ id: spray, quantity: 1, properties: { _upsell: 'true' } }], 0, 0); })['catch'](function () {});
    } else if (action === 'spray-remove') {
      var row = control.closest('.tq-gift');
      if (row) { row.classList.add('is-leaving'); }
      var keys = list(control.getAttribute('data-keys'));
      enqueue(function () {
        var updates = {};
        keys.forEach(function (key) { updates[key] = 0; });
        return setQty(updates, 0, 0);
      })['catch'](function () {});
    } else if (action === 'nudge') {
      track('cart_upsell_click', { item: 'pot' });
      var next = int(control.getAttribute('data-variant-id'));
      var more = int(control.getAttribute('data-qty')) || 1;
      var target = findLine(next + ':0:p');
      control.classList.add('is-leaving');
      control.disabled = true;
      if (target) {
        bump(target, more, true, true);
      } else {
        enqueue(function () { return addItems([{ id: next, quantity: more }], more, 0); })['catch'](function () {});
      }
    }
  });

  /* Le prix du pot suivant, au taux du marché (les remises sont en euros, voir snippets/tq-head). */
  function convertStep() {
    if (!TQ.rate || TQ.rate() === 1) { return; }
    var nudge = doc.querySelector('#sidebar-cart [data-tq="nudge"][data-unit]');
    var label = nudge && nudge.querySelector('[data-tq-step]');
    if (!label) { return; }
    var step = parseInt(nudge.getAttribute('data-unit'), 10) - TQ.discount(parseInt(nudge.getAttribute('data-off'), 10)) - (parseInt(nudge.getAttribute('data-spray'), 10) || 0);
    var codeOff = parseFloat(nudge.getAttribute('data-code-off')) || 0;
    if (codeOff > 0) { step = Math.round(parseInt(nudge.getAttribute('data-unit'), 10) * (100 - codeOff) / 100) - TQ.discount(parseInt(nudge.getAttribute('data-off'), 10)) - (parseInt(nudge.getAttribute('data-spray'), 10) || 0); }
    label.textContent = TQ.money(Math.max(0, step));
  }
  doc.addEventListener('cart:updated', convertStep);

  /*
   * Filet : le panneau rendu dit si les cadeaux sont d'accord avec les pots
   * (un raté réseau, un seuil de l'admin), si un cadeau est facturé, si un
   * spray payant est resté alors qu'il est offert. On recale alors une fois
   * sur /cart.js, sans boucler, et seulement quand plus rien n'est en route.
   */
  var healed = '';
  function heal() {
    var f = form();
    if (!f || inflight || Object.keys(pend).length) { return; }
    var st = domState();
    var plan = giftPlan(st, st.pots, st.subs);
    var charged = f.querySelectorAll('.tq-gift[data-charged]').length;
    var wrong = plan.adds.length || Object.keys(plan.updates).length || charged;
    var key = st.pots + ':' + st.subs + ':' + JSON.stringify(st.gifts) + ':' + st.upsell.join() + ':' + charged;
    if (!wrong || healed === key) { return; }
    healed = key;
    enqueue(function () { return sync().then(function () { return null; }); })['catch'](function () {});
  }
  doc.addEventListener('cart:updated', heal);
  doc.addEventListener('drawer:opened', function (event) { if (event.target && event.target.id === 'sidebar-cart') { heal(); } });
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', convertStep); } else { convertStep(); }

  doc.addEventListener('drawer:opened', function (event) {
    if (event.target && event.target.id === 'sidebar-cart') { track('cart_open', {}); }
  });

  /* ── Panneaux : glisser vers le bas pour fermer (téléphone) ───────── */

  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 759px)') : { matches: true };

  /*
   * Les écouteurs sont posés sur chaque panneau, touchmove non passif dès le
   * départ : Safari décide au toucher si le défilement peut être bloqué, un
   * écouteur ajouté pendant le geste arrivait trop tard (le panneau ne
   * suivait pas le doigt). Vers le bas, depuis l'en-tête, le pied ou le haut
   * de la liste, le panneau suit dès le premier pixel ; vers le haut, la liste
   * défile normalement. Bloquer ce geste empêche aussi Chrome de recharger
   * la page en tirant vers le bas.
   */
  function bindSheet(sheet) {
    var g = null;
    sheet.addEventListener('touchstart', function (event) {
      g = null;
      if (!MOBILE.matches || event.touches.length !== 1 || sheet.getAttribute('aria-hidden') !== 'false') { return; }
      if (event.target.closest('input, select, textarea, .tq-line__shades, .tq-shades__pots')) { return; }
      var scroller = (sheet.classList.contains('is-shading') && sheet.querySelector('.tq-shades__body')) || sheet.querySelector('[data-scrollable]');
      var inList = !!(scroller && scroller.contains(event.target)) && !event.target.closest('.tq-sheet__grip, .tq-cart__head, .tq-photo__head');
      g = { y0: event.touches[0].clientY, x0: event.touches[0].clientX, dy: 0, on: false, list: inList, scroller: scroller, pts: [], raf: 0 };
    }, { passive: true });
    var paint = function () {
      if (!g) { return; }
      g.raf = 0;
      sheet.style.transform = 'translate3d(0,' + g.dy + 'px,0)';
      var veil = doc.querySelector('.PageOverlay');
      if (veil) { veil.style.transition = 'none'; veil.style.opacity = String(Math.max(0, 1 - g.dy / (sheet.offsetHeight || 600))); }
    };
    var release = function (to, ms) {
      clearTimeout(sheet._tqSettle);
      sheet.classList.remove('is-dragging');
      sheet.style.transition = 'transform ' + ms + 'ms cubic-bezier(0.2, 0.8, 0.2, 1), visibility ' + ms + 'ms';
      sheet.style.transform = to;
      var veil = doc.querySelector('.PageOverlay');
      if (veil) { veil.style.transition = 'opacity ' + ms + 'ms cubic-bezier(0.2, 0.8, 0.2, 1), visibility ' + ms + 'ms'; veil.style.opacity = ''; }
      sheet._tqSettle = setTimeout(function () {
        sheet.classList.remove('is-moving');
        sheet.style.transition = '';
        if (veil) { veil.style.transition = ''; }
      }, ms + 60);
    };
    sheet.addEventListener('touchmove', function (e) {
      if (!g) { return; }
      var y = e.touches[0].clientY - g.y0;
      if (!g.on) {
        if (g.list && g.scroller.scrollTop > 0) { g = null; return; }
        if (y <= 0) {
          if (y < -3 || Math.abs(e.touches[0].clientX - g.x0) > 10) { g = null; }
          return;
        }
        if (Math.abs(e.touches[0].clientX - g.x0) > y * 1.5) { g = null; return; }
        g.on = true;
        clearTimeout(sheet._tqSettle);
        sheet.style.transition = '';
        sheet.classList.add('is-dragging', 'is-moving');
      }
      if (e.cancelable) { e.preventDefault(); }
      g.dy = Math.max(0, y);
      var now = e.timeStamp || Date.now();
      g.pts.push([now, g.dy]);
      while (g.pts.length > 2 && now - g.pts[0][0] > 100) { g.pts.shift(); }
      if (!g.raf) { g.raf = requestAnimationFrame(paint); }
    }, { passive: false });
    var end = function () {
      if (!g || !g.on) { g = null; return; }
      if (g.raf) { cancelAnimationFrame(g.raf); }
      var dy = g.dy;
      var a = g.pts[0], b = g.pts[g.pts.length - 1];
      var v = a && b && b[0] > a[0] ? (b[1] - a[1]) / (b[0] - a[0]) : 0;
      g = null;
      var h = sheet.offsetHeight || 600;
      if ((dy > h * 0.25 && v > -0.2) || (dy > 20 && v > 0.45)) {
        /* « Vos teintes » ouvert : le geste revient au panier (annuler), sans le fermer. */
        if (sheet.id === 'sidebar-cart' && window.tqCartShadesBack && window.tqCartShadesBack()) { release('', 320); return; }
        var close = sheet.querySelector('[data-action="close-drawer"]');
        var ms = Math.round(Math.min(380, Math.max(200, (h + 40 - dy) / Math.max(v, 1.4) * 1.6)));
        release('', ms);
        if (close) { close.click(); }
      } else {
        release('', 360);
      }
    };
    sheet.addEventListener('touchend', end);
    sheet.addEventListener('touchcancel', end);
  }
  function bindSheets() {
    var list = doc.querySelectorAll('.tq-sheet');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].hasAttribute('data-tq-drag')) { list[i].setAttribute('data-tq-drag', ''); bindSheet(list[i]); }
    }
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', bindSheets); } else { bindSheets(); }
  doc.addEventListener('drawer:opened', bindSheets);

  function smoothHeight() {
    var sheet = doc.getElementById('sidebar-cart');
    if (!sheet || !window.ResizeObserver || sheet.classList.contains('tq-cart-page')) { return; }
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var last = 0;
    var busy = false;
    var end = function () {
      sheet.style.height = '';
      sheet.style.transition = '';
      busy = false;
      last = sheet.offsetHeight;
    };
    new ResizeObserver(function () {
      if (busy) { return; }
      var h = sheet.offsetHeight;
      var from = last;
      last = h;
      if (!from || still || !MOBILE.matches || Math.abs(h - from) < 2 || sheet.getAttribute('aria-hidden') !== 'false' || sheet.classList.contains('is-dragging')) { return; }
      busy = true;
      sheet.style.height = from + 'px';
      void sheet.offsetHeight;
      sheet.style.transition = getComputedStyle(sheet).transition + ', height 0.42s cubic-bezier(0.2, 0.8, 0.2, 1)';
      sheet.style.height = h + 'px';
      var done = false;
      var finish = function (event) {
        if (done || (event && (event.target !== sheet || event.propertyName !== 'height'))) { return; }
        done = true;
        sheet.removeEventListener('transitionend', finish);
        end();
      };
      sheet.addEventListener('transitionend', finish);
      window.setTimeout(finish, 600);
    }).observe(sheet);
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', smoothHeight); } else { smoothHeight(); }
})();
